import React, { useState, useEffect } from "react";
import {
  Container,
  Nav,
  Navbar,
  Modal,
  Col,
  Row,
  Table,
  Offcanvas,
} from "react-bootstrap";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";
import { MdOutlineClose } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, Navigate } from "react-router-dom";
import API_DOMAIN from "../config/config";

import moment from "moment/moment";
import PayInPdf from "./PayInPdf";
const ProductHistory = [
  "S No",
  "Date",
  "Receipt No.",
  "Name",
  "Amount",
  "Status",
];

const calculateOutstanding = (party) => {
  if (!party || !party.transactions) return 0;
  let totalInvoices = 0;
  let totalPaidInvoices = 0;
  let totalPayins = 0;
  party.transactions.forEach((t) => {
    if (t.type === "Invoice") {
      totalInvoices += parseFloat(t.amount) || 0;
      totalPaidInvoices += parseFloat(t.paid) || 0;
    } else if (t.type === "Payin") {
      totalPayins += parseFloat(t.amount) || 0;
    }
  });
  const opening = parseFloat(party.opening_balance) || 0;
  return opening + totalInvoices - totalPaidInvoices - totalPayins;
};

const PayIn = () => {
  const navigate = useNavigate();
  //   const [cookies, setCookie] = useCookies(['company_id']);
  const [openFilter, setFilter] = useState(false);
  const closeFilter = () => setFilter(false);
  const showFilter = () => setFilter(true);
  const [show, setShow] = useState(false);

  const [outstanding, setOutstanding] = useState(0);

  const handleClose = () => {
    setShow(false);
    setCrtPayIn(null);
    setFormData({
      party_id: "",
      receipt_date: new Date(),
      paid: "",
      payment_method_id: "",
      details: "",
    });
    setOutstanding(0);
  };
  const handleShow = () => {
    setCrtPayIn(null);
    setFormData({
      party_id: "",
      receipt_date: new Date(),
      paid: "",
      payment_method_id: "",
      details: "",
    });
    setOutstanding(0);
    setShow(true);
  };
  const [loading, setLoading] = useState(true);
  // useEffect(() => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //   });
  // });
  const [crtPayIn, setCrtPayIn] = useState(null);
  // const handleEditClick = (rowdata) => {
  //   setCrtPayIn(rowdata);
  //   setShow(true);
  // };
  const handleEditClick = (rowdata) => {
    const isValidDate = moment(
      rowdata.receipt_date,
      ["YYYY-MM-DD", "DD-MM-YYYY"],
      true
    ).isValid();
    const parsedDate = isValidDate
      ? moment(
          rowdata.receipt_date,
          ["YYYY-MM-DD", "DD-MM-YYYY"],
          true
        ).toDate()
      : new Date();

    setCrtPayIn({
      ...rowdata,
      receipt_date: parsedDate,
    });

    setShow(true);
  };
  const [formData, setFormData] = useState({
    party_id: "",
    receipt_date: new Date(),
    paid: "",
    payment_method_id: "",
    details: "",
  });
  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    if (crtPayIn != null) {
      setCrtPayIn({
        ...crtPayIn,
        [fieldName]: value,
      });
    } else {
      setFormData({
        ...formData,
        [fieldName]: value,
      });
    }
  };
  const setLabel = (value, field) => {
    const dateValue = moment(value);
    if (!dateValue.isValid()) {
      return;
    }

    setFormData({
      ...formData,
      [field]: dateValue.format("YYYY-MM-DD"),
    });
  };

  const [filterData, setFilterData] = useState({
    search_text: "",
    party_id: "",
    from_date: "",
    to_date: "",
    payment_method_id: "",
  });
  const handleChanges = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };
  const setLabell = (value, field) => {
    setFilterData({
      ...filterData,
      [field]: moment(value).format("YYYY-MM-DD"), // Update the specified field in formData with the provided value
    });
  };
  const [crtSalesParty, setSalesParty] = useState([]);
  const [crtPaymentMethod, setCrtPaymentMethod] = useState([]);
  const fetchDataSalesparty = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.code === 200) {
        setSalesParty(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  const fetchDataPaymentMethod = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/paymentmethod.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: "",
          }),
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setCrtPaymentMethod(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchDataSalesparty();
    fetchDataPaymentMethod(); // Call fetchData directly in useEffect
  }, []);
  const [userData, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/payin.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: filterData.search_text,
          party_id: filterData.party_id,
          from_date: filterData.from_date,
          to_date: filterData.to_date,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      setLoading(false);
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData(); // Call fetchData directly in useEffect
  }, [filterData]);

  const [dropdownKey, setDropdownKey] = useState(Date.now());

  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: "",
      to_date: "",
      payment_method_id: "",
      details: "",
    });
    setDropdownKey(Date.now()); // force DropDownUI to reset
  };
  const setFormattedDate = (
    value,
    field,
    format = "YYYY-MM-DD",
    isFilter = false
  ) => {
    const formattedDate = value ? moment(value).format(format) : null;

    if (!formattedDate || !moment(formattedDate, format, true).isValid()) {
      return;
    }

    const newDateState = { [field]: formattedDate };

    if (isFilter) {
      setFilterData((prev) => ({ ...prev, ...newDateState }));
    } else if (crtPayIn !== null) {
      setCrtPayIn((prev) => ({ ...prev, ...newDateState }));
    } else {
      setFormData((prev) => ({ ...prev, ...newDateState }));
    }
  };
  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const [showAlert, setShowAlert] = useState(false);
  const [showPdf, setShowPdf] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/payin.php?id=${companyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          party_id: formData.party_id,
          receipt_date: formData.receipt_date,
          paid: formData.paid,
          payment_method_id: formData.payment_method_id,
          details: formData.details,
        }),
      });
      setLoading(false);
      if (!response.ok) {
        throw new Error("Failed to update company");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        successAlert(responseData.msg);
        setTimeout(() => {
          fetchData();
          handleClose();
          window.location.reload();
        }, 2000);
      } else {
      }
    } catch (error) {
    }

    setLoading(false);
  };

  const handleUpdateSubmit = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/payin.php?id=${companyId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          // Include the company ID in the request
          payin_id: crtPayIn.payin_id,
          paid: crtPayIn.paid,
          receipt_date: crtPayIn.receipt_date,
          party_id: crtPayIn.party_id,
          payment_method_id: crtPayIn.payment_method_id,
          details: crtPayIn.details,
        }),
      });
      setLoading(false);

      if (!response.ok) {
        throw new Error("Failed to update company");
      }

      const responseData = await response.json();

      if (responseData.status === 200) {
        successAlert(responseData.msg);
        setTimeout(() => {
          fetchData();
          handleClose();
          window.location.reload();
        }, 2000);

        // Navigate to the user list page after a delay
      } else {
      }
    } catch (error) {
    }

    setLoading(false);
  };
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        // Check session logic here, e.g., fetch from local storage or server
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);
  useEffect(() => {
    const currentPartyId = crtPayIn ? crtPayIn.party_id : formData.party_id;
    if (currentPartyId && crtSalesParty.length > 0) {
      const party = crtSalesParty.find((p) => p.party_id === currentPartyId);
      if (party) {
        setOutstanding(calculateOutstanding(party));
      } else {
        setOutstanding(0);
      }
    } else {
      setOutstanding(0);
    }
  }, [formData.party_id, crtPayIn?.party_id, crtSalesParty]);
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  if (loading) {
    return <LoadingSpinner message="Loading Sales PayIn..." height="300px" />;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="pt-2">
        <div>
          <div className="main p-3 my-2">
            <div className="mx-2">
              <Navbar>
                <Navbar.Brand>
                  <PageTitle PageTitle={"Pay In"} />
                </Navbar.Brand>
                <Nav className="ms-auto">
                  {/* <span className='mx-2 py-2'> <Buttons lable={<>PDF</>} /></span> */}
                  <span className="mx-2 py-2">
                    <Buttons lable={<>Filter</>} onClick={showFilter} />
                  </span>
                </Nav>
              </Navbar>
            </div>
            <Offcanvas show={openFilter} onHide={closeFilter} placement="end">
              <Offcanvas.Body>
                <Row>
                  <Col lg="6">
                    <PageTitle PageTitle={<>Purchase Bill</>} />
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="text-end">
                      <Buttons
                        onClick={closeFilter}
                        lable={
                          <>
                            <MdOutlineClose />
                          </>
                        }
                      ></Buttons>
                    </div>
                  </Col>
                </Row>
                <div>
                  <div className="py-3">
                    <TextInputForm
                      labelname={"Search Receipt"}
                      placeholder={"Search Receipt"}
                      name="search_text"
                      value={filterData.search_text}
                      onChange={(e) => handleChanges(e, "search_text")}
                    ></TextInputForm>
                  </div>
                  <div className="py-3">
                    <DropDownUI
                      key={dropdownKey}
                      optionlist={crtSalesParty.map((user) => ({
                        value: user.party_id,
                        label: user.party_name,
                      }))}
                      placeholder="PartyName"
                      labelname="PartyName"
                      name="party_id"
                      value={filterData.party_id}
                      onChange={(updatedFormData) =>
                        setFilterData({
                          ...filterData,
                          party_id: updatedFormData.party_id,
                        })
                      }
                    />
                  </div>
                  <Row>
                    <Col lg="6" className="align-self-center">
                      <Calender
                        key={dropdownKey}
                        calenderlabel="From Date"
                        selectedDate={
                          filterData.from_date &&
                          moment(
                            filterData.from_date,
                            "YYYY-MM-DD",
                            true
                          ).isValid()
                            ? moment(
                                filterData.from_date,
                                "YYYY-MM-DD"
                              ).toDate()
                            : null
                        }
                        setLabel={(date) =>
                          setFormattedDate(
                            date,
                            "from_date",
                            "YYYY-MM-DD",
                            true
                          )
                        }
                        disabled={false}
                      />
                    </Col>
                    <Col lg="6" className="align-self-center">
                      <Calender
                        key={dropdownKey}
                        calenderlabel="To Date"
                        selectedDate={
                          filterData.to_date &&
                          moment(
                            filterData.to_date,
                            "YYYY-MM-DD",
                            true
                          ).isValid()
                            ? moment(filterData.to_date, "YYYY-MM-DD").toDate()
                            : null
                        }
                        setLabel={(date) =>
                          setFormattedDate(date, "to_date", "YYYY-MM-DD", true)
                        }
                        disabled={false}
                      />
                    </Col>
                    {/* <Col lg="6" className="align-self-center">
                      <div>
                        <Calender
                          key={dropdownKey}
                          setLabel={(date) => setLabell(date, "from_date")}
                          selectedDate={filterData.from_date}
                          calenderlabel="From Date"
                        />
                      </div>
                    </Col>
                    <Col lg="6" className="align-self-center">
                      <div>
                        <Calender
                          key={dropdownKey}
                          setLabel={(date) => setLabell(date, "to_date")}
                          selectedDate={filterData.to_date}
                          calenderlabel="To Date"
                        />
                      </div>
                    </Col> */}

                    <Col lg="12" className="align-self-center">
                      <div className="my-5 text-center">
                        <Buttons
                          lable={"Clear"}
                          onClick={clearFilter}
                        ></Buttons>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
          <div className="main p-3">
            <div className="py-1 mx-2">
              <Navbar>
                <Navbar.Brand>
                  <PageTitle PageTitle={"Transactions"} />
                </Navbar.Brand>
                <Nav className="ms-auto">
                  <span className="mx-2 py-2">
                    {" "}
                    <Buttons lable={<>Add New</>} onClick={handleShow} />
                  </span>
                </Nav>
              </Navbar>
            </div>
            <div className="py-2 table-scroll">
              <TableUI
                headers={ProductHistory}
                body={userData}
                type="salespayin"
                pageview={"yes"}
                handleEditClick={handleEditClick}
                onDelete={fetchData}
              />
            </div>
          </div>
          <>
            <Modal
              show={show}
              onHide={handleClose}
              size="xl"
              centered
              scrollable
            >
              <Modal.Header>
                <Modal.Title>
                  <PageHead pagehead={<>Pay In</>} onClick={handleClose} />
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container fluid>
                  <Table>
                    <>
                      <div className="row">
                        <div className="col-12 col-md-4">
                          <Calender
                            calenderlabel="Date"
                            selectedDate={
                              (crtPayIn
                                ? crtPayIn.receipt_date
                                : formData.receipt_date) &&
                              moment(
                                crtPayIn
                                  ? crtPayIn.receipt_date
                                  : formData.receipt_date,
                                "DD-MM-YYYY",
                                true
                              ).isValid()
                                ? moment(
                                    crtPayIn
                                      ? crtPayIn.receipt_date
                                      : formData.receipt_date,
                                    "DD-MM-YYYY"
                                  ).toDate()
                                : null
                            }
                            setLabel={(date) =>
                              setFormattedDate(
                                date,
                                "receipt_date",
                                "DD-MM-YYYY",
                                false
                              )
                            }
                            disabled={false}
                          />
                        </div>

                        {/* 2. Select Party */}
                        <div className="col-12 col-md-4">
                          <DropDownUI
                            optionlist={crtSalesParty.map((user) => ({
                              value: user.party_id,
                              label: user.party_name,
                            }))}
                            placeholder="Select Party"
                            labelname="Select Party"
                            name="party_id"
                            value={
                              crtPayIn != null
                                ? crtPayIn.party_id
                                : formData.party_id
                            }
                            onChange={(updatedFormData) => {
                              if (crtPayIn != null) {
                                setCrtPayIn({
                                  ...crtPayIn,
                                  party_id: updatedFormData.party_id,
                                });
                              } else {
                                setFormData({
                                  ...formData,
                                  party_id: updatedFormData.party_id,
                                });
                              }
                            }}
                          />
                        </div>

                        {/* 3. Select Payment */}
                        <div className="col-12 col-md-4">
                          <DropDownUI
                            optionlist={crtPaymentMethod.map((user) => ({
                              value: user.payment_method_id,
                              label: user.payment_method_name,
                            }))}
                            placeholder="Select Payment"
                            labelname="Select Payment"
                            name="payment_method_id"
                            value={
                              crtPayIn !== null
                                ? crtPayIn.payment_method_id
                                : formData.payment_method_id
                            }
                            onChange={(updatedFormData) => {
                              if (crtPayIn !== null) {
                                setCrtPayIn({
                                  ...crtPayIn,
                                  payment_method_id:
                                    updatedFormData.payment_method_id,
                                });
                              } else {
                                setFormData({
                                  ...formData,
                                  payment_method_id:
                                    updatedFormData.payment_method_id,
                                });
                              }
                            }}
                          />
                        </div>
                      </div>

                      {/* --- Second Row: Details and Paid (3 Columns for alignment) --- */}
                      <div className="row">
                        {/* 1. Details (Added based on your request) */}
                        <div className="col-12 col-md-4">
                          <div className="py-3">
                            <TextInputForm
                              labelname={"Details"}
                              placeholder={"Enter Details (Optional)"}
                              name="details"
                              value={
                                crtPayIn !== null
                                  ? crtPayIn.details
                                  : formData.details
                              }
                              // Assuming you have a handleChange function defined
                              onChange={(e) => handleChange(e, "details")}
                            />
                          </div>
                        </div>

                        {/* 2. Paid */}
                        <div className="col-12 col-md-4">
                          <div className="py-3">
                            <TextInputForm
                              labelname="Paid"
                              placeholder="Paid"
                              name="paid"
                              value={
                                crtPayIn !== null
                                  ? crtPayIn.paid
                                  : formData.paid
                              }
                              onChange={(e) => handleChange(e, "paid")}
                            />
                          </div>
                        </div>

                        {/* 3. Empty Column for Alignment */}
                        <div className="col-12 col-md-4">
                          {/* Spacer column to maintain alignment with the row above */}
                        </div>
                      </div>

                      {/* Outstanding Card */}
                      {outstanding > 0 && (
                        <div className="row mt-3">
                          <div className="col-12">
                            <div className="card">
                              <div className="card-body text-center">
                                <h6 className="text-danger">
                                  Outstanding Amount: ₹{outstanding.toFixed(2)}
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  </Table>
                  {/* <Row>
                    <Col lg="6"></Col>
                    <Col lg="6">
                      <div></div>
                    </Col>
                  </Row> */}
                </Container>
              </Modal.Body>
              <Modal.Footer>
                <div className="text-center">
                  {crtPayIn != null ? (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Update</>}
                          onClick={handleUpdateSubmit}
                          disabled={loading}
                        ></ClickButton>
                      </span>

                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={handleClose}
                        ></ClickButton>
                      </span>
                    </>
                  ) : (
                    <>
                      <ToastContainer
                        position="top-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="light"
                      />
                      <span className="mx-2">
                        <ClickButton
                          label={<>Submit</>}
                          onClick={handleSubmit}
                          disabled={loading}
                        ></ClickButton>
                      </span>

                      <span className="mx-2">
                        <ClickButton
                          label={<>Cancel</>}
                          onClick={() => {
                            handleClose();
                          }}
                        ></ClickButton>
                      </span>
                    </>
                  )}
                </div>
              </Modal.Footer>
            </Modal>
          </>
        </div>
      </Container>
      {/* {showPdf && <PayInPdf type="print" />} */}
    </div>
  );
};

export default PayIn;

